// Atalho "+ Adicionar" da fornecedora (spec 27/09, Parte 4): abre a
// importacao com "O que importar" e a fornecedora ja escolhidos. Tabela
// continua nascendo SO da planilha.
export type TipoImportacao = 'produtos' | 'clientes' | 'aliquotas'
const TIPOS: readonly TipoImportacao[] = ['produtos', 'clientes', 'aliquotas']

export function preenchimentoDaUrl(params: URLSearchParams): { tipo: TipoImportacao; representadaId: string } {
  const t = params.get('tipo')
  return {
    tipo: t !== null && (TIPOS as readonly string[]).includes(t) ? (t as TipoImportacao) : 'produtos',
    representadaId: params.get('representada') ?? '',
  }
}
